import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardActions,
} from '@mui/material';
import {
  AddCircleOutline as AddIcon,
  FormatListBulleted as ListIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import AppHeader from '../components/AppHeader';

const Dashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <>
      <AppHeader />

      <Container maxWidth="lg">
        <Box sx={{ mt: 6, mb: 4 }}>
          <Typography variant="h3" gutterBottom>
            Welcome, {user?.fullName || user?.username}!
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            Enterprise cloud infrastructure cost calculator with multi-provider support
          </Typography>
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <AddIcon color="secondary" sx={{ fontSize: 40, mr: 2 }} />
                  <Typography variant="h5" component="div">
                    Create New Quote
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  Build a new infrastructure quote by selecting providers, regions, VMs, and services.
                  Compare costs across different providers and regions to find the best option.
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  size="large"
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={() => navigate('/quote-builder')}
                >
                  Start Building
                </Button>
              </CardActions>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <ListIcon color="secondary" sx={{ fontSize: 40, mr: 2 }} />
                  <Typography variant="h5" component="div">
                    My Quotes
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  View, edit, and manage your saved quotes. Load previous quotes to update pricing
                  or make modifications. Export quotes to PDF for sharing.
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  size="large"
                  variant="outlined"
                  fullWidth
                  onClick={() => navigate('/my-quotes')}
                >
                  View My Quotes
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>

        {user?.isAdmin && (
          <Box sx={{ mt: 4 }}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <SettingsIcon color="secondary" sx={{ fontSize: 40, mr: 2 }} />
                  <Typography variant="h5" component="div">
                    Administration
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary" paragraph>
                  Manage providers, regions, VM types, OS options, addons, and pricing.
                  Configure default addons and manage user access.
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => navigate('/admin')}
                >
                  Go to Admin Area
                </Button>
              </CardContent>
            </Card>
          </Box>
        )}

        <Box sx={{ mt: 4, mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            Quick Tips
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            • Select your provider and region first to see accurate pricing
          </Typography>
		  <Typography variant="body2" color="text.secondary" paragraph>
            • Switching provider or region updates the pricing for the items selected
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            • Some default services are already included in the VM / Dataase on VM costs. These are detailed on the page
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            • Save quotes to reload them later.
          </Typography>
		  <Typography variant="body2" color="text.secondary" paragraph>
            • Download copies of quotes in PDF/Excel
          </Typography>
        </Box>
      </Container>
    </>
  );
};

export default Dashboard;
